import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './api/index'
import './utlis/filters'
import './utlis/global'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/base.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import './style/element-variables.scss'
import './style/index.less'
import BaiduMap from 'vue-baidu-map'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import 'social-share.js/dist/js/social-share.min'
import './utlis/socket'

Vue.use(preview)
Vue.use(BaiduMap, {
  ak: 'nwYcOwq6tGviC2pzgNsOHfVZ9nCpmh28'
})

Vue.component(CollapseTransition.name, CollapseTransition)
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
